import AverageLeadTimeIcon from './component'

export default AverageLeadTimeIcon
